export default "__VITE_ASSET__D1pEfW84__"